import { filter_slas, sort_slas } from './service_layer_agreement.collection_helpers';

export const computed = {
  total_slas() {
    return this.sla_configs.length;
  },
  active_slas() {
    return this.sla_configs.filter((item) => item.is_active !== false).length;
  },
  metrics() {
    return [
      { label: 'Total SLAs', value: String(this.total_slas), icon: 'bi-bell-fill' },
      { label: 'Active SLAs', value: String(this.active_slas), icon: 'bi-toggle-on' },
    ];
  },
  filtered_slas() {
    const filtered_items = filter_slas(this.sla_configs, this.search_query, this.filter_mode);
    return filtered_items;
  },
  sorted_slas() {
    const sorted_items = sort_slas(this.filtered_slas, this.sort_mode);
    return sorted_items;
  },
  paginated_slas() {
    const start = (this.current_page - 1) * this.page_size;
    return this.sorted_slas.slice(start, start + this.page_size);
  },
  total_pages() {
    return Math.max(1, Math.ceil(this.sorted_slas.length / this.page_size));
  },
  pagination_label() {
    if (!this.sorted_slas.length) return 'Showing 0 results';
    const start = ((this.current_page - 1) * this.page_size) + 1;
    const end = Math.min(this.current_page * this.page_size, this.sorted_slas.length);
    return `Showing ${start} to ${end} of ${this.sorted_slas.length} results`;
  },
};

export const watch = {
  search_query() { this.current_page = 1; },
  filter_mode() { this.current_page = 1; },
  sort_mode() { this.current_page = 1; },
};
